import {
  Box,
} from "@chakra-ui/react";
import { useState } from "react";
import {  useParams } from "react-router-dom";
import { useGetState } from "../../context/useGetState";
import InterestScreen from "../signupSteps/InterestScreen";
import EmailScreen from "../signupSteps/EmailScreen";
import MoreInfoScreen from "../signupSteps/MoreInfoScreen";
import OTPScreen from "../signupSteps/OTPScreen";
import UserBio from "../signupSteps/UserBio";
import Signin from "../signin/SignIn";

function RegisterSteps(props) {
  let { id } = useParams();
  console.log('id-->',id)
  const { state } = useGetState();


  const [profileInfo, setProfileInfo] = useState({});
  const [, setBtnLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [about, setAbout] = useState(
    state?.userInfo?.about ? state?.userInfo?.about : "not available"
  );

  return (
    <>
      {id == 'register' ? (
        <EmailScreen />
      ) : id == 'otp' ? (
        <OTPScreen />
      ) : id == 'bio' ? (
        <UserBio />
      ) : id == 'info' ? (
        <MoreInfoScreen />
      ) : id == 'interests' ? (
        <InterestScreen />
      ) : (
        <EmailScreen />
      )}

      {/* {id == 'register' ? (
        <EmailScreen />
      ) : id == 'bio' ? (
        <UserBio />
      ) : id == 'info' ? (
        <MoreInfoScreen />
      ) : id == 'interests' ? (
        <InterestScreen />
      ) : (
        <EmailScreen />
      )} */}

      <Box
        p="5px 10px"
        cursor={"pointer"}
        borderRadius={"5px"}
        bg="#FF0000"
        color="#fff"
        alignSelf={"flex-end"}
        mr="-30px !important"
        mb="-5px !important"
        display={"none"}
      >
        Report this User
      </Box>
    </>
  );
}

export default RegisterSteps;
